import styled from 'styled-components';

export const SearchLabel = styled.div`
    display: flex;
    width: 70%;
    margin-bottom: 12px;
    align-items: center;
`;


export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 440px;
  margin-bottom: 12px;
`;

export const Input = styled.input`
  flex: 1;
  height: 40px;
  padding: 0 8px 0 32px;
  background: url('/loop.svg') no-repeat 8px center;
  background-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
`;
